import React, { useEffect, useState } from "react";
import CustomComponent from "./CustomComponent";
import EditPen from "assets/svgs/edit_pen";
import Message from "assets/svgs/message";
import { usePrescription } from "./store";
import {
  adminRole,
  canMarkInprogress,
  doctor,
  getCurrentUserRole,
  medRepRoles,
  orderCancellation,
  orderCancellationDisabledStatus,
  supportRole,
} from "modules/utilities/utility";
import {
  UserAddOutlined,
  CheckOutlined,
  CloseOutlined,
  ShoppingOutlined,
  RocketOutlined,
  FileTextTwoTone,
  ExceptionOutlined,
  SyncOutlined,
  TagsOutlined,
  ScheduleOutlined,
  SafetyOutlined,
  PauseOutlined,
  UpCircleOutlined,
} from "@ant-design/icons";
import TickInCircle from "assets/svgs/tick_in_cirlce";
import ReturnRequest from "assets/svgs/return_request";
import ReturnToOrigin from "assets/svgs/rto";
import Reattempt from "assets/svgs/reattempt";
import secureLocalStorage from "react-secure-storage";

const actionButtonStyle =
  "mt-n1 bg-primary text-white d-flex justify-content-center align-items-center p-2 rounded-circle shadow";

const bulkOrder = { "Bulk Order": <TickInCircle /> };
const subscriptionOrder = {
  "as subscription order": (
    <div className={actionButtonStyle}>
      <ScheduleOutlined />
    </div>
  ),
};
const singleOrder = {
  "as single order": (
    <div className={actionButtonStyle}>
      <SafetyOutlined />
    </div>
  ),
};

const assignDoctor = { "Assign Doctor": <UserAddOutlined /> };
const assignClinic = { "Assign Clinic": <UserAddOutlined /> };
const sendToDispatch = { "Send To Dispatch": <CheckOutlined /> };
const engagements = { Engagements: <Message /> };
const prescription = { Prescription: <EditPen /> };
const markAsDelivered = { "Mark as Delivered ": <ShoppingOutlined /> };
const voidOrder = { "Void Order": <ExceptionOutlined /> };
const RTOVoidOrder = { "RTO Void Order": <TagsOutlined /> };
const assignBack = { "Assign Back": <PauseOutlined /> };
const updateWarehouseAndMarkShipped = {
  "Update Warehouse & Mark Shipped": <RocketOutlined />,
};
const cancelFullFilament = {
  "Cancel Fulfillment": <UpCircleOutlined />,
};
const downloadPrescription = {
  "Download Prescription": (
    <div className={actionButtonStyle}>
      <FileTextTwoTone />
    </div>
  ),
};
const resyncOrder = {
  "Resync Order": (
    <div className={actionButtonStyle}>
      <SyncOutlined />
    </div>
  ),
};

const returnRequest = { "Return Order": <ReturnRequest /> };

const commonActions = {
  "Assign Doctor": <UserAddOutlined />,
  Prescription: <EditPen />,
  "Send To Dispatch": <CheckOutlined />,
  Engagements: <Message />,
  "Resync Order": (
    <div className={actionButtonStyle}>
      <SyncOutlined />
    </div>
  ),
  "Download Prescription": (
    <div className={actionButtonStyle}>
      <FileTextTwoTone />
    </div>
  ),
};
const cancelOrderAction = { "Cancel Order": <CloseOutlined /> };
const rto = { "Initiate RTO": <ReturnToOrigin /> };
const reattempt = { "Reattempt Request": <Reattempt /> };
const supportActions = {
  Prescription: <EditPen />,
  Engagements: <Message />,
  "Download Prescription": (
    <div className={actionButtonStyle}>
      <FileTextTwoTone />
    </div>
  ),
};
const adminActions = {
  "Mark as Delivered ": <ShoppingOutlined />,
  "Update Warehouse & Mark Shipped": <RocketOutlined />,
  "Void Order": <ExceptionOutlined />,
  "RTO Void Order": <TagsOutlined />,
};

const doctorActions = {
  "Assign Back": <PauseOutlined />,
};
const deprecatedActions = {
  "Bulk Order": <TickInCircle />,
  "as subscription order": (
    <div className={actionButtonStyle}>
      <ScheduleOutlined />
    </div>
  ),
  "as single order": (
    <div className={actionButtonStyle}>
      <SafetyOutlined />
    </div>
  ),
};

function OrderActions({ order, customerId, userId, prescriptions, customer }) {
  // const cancellationRemove=["ivr"];

  const actions = () => {
    const role = getCurrentUserRole();
    let actionsToReturn = {};
    if (doctor.includes(role) || role === "operations") {
      actionsToReturn = {
        ...assignDoctor,
        ...assignClinic,
        ...prescription,
        ...sendToDispatch,
        ...engagements,
        ...downloadPrescription,
        ...rto,
        ...reattempt
      };
      if (canMarkInprogress.includes(role)) {
        actionsToReturn = { ...actionsToReturn, ...assignBack };
      }
    } else if (medRepRoles.includes(role)) {
      actionsToReturn = {
        ...assignDoctor,
        ...assignClinic,
        ...prescription,
        ...sendToDispatch,
        ...engagements,
        ...resyncOrder,
        ...downloadPrescription,
        ...rto,
        ...reattempt
      };
    } else if (adminRole.includes(role) || role === "dispatch") {
      actionsToReturn = {
        ...assignDoctor,
        ...assignClinic,
        ...prescription,
        ...sendToDispatch,
        ...engagements,
        ...markAsDelivered,
        ...updateWarehouseAndMarkShipped,
        // ...voidOrder,
        ...RTOVoidOrder,
        ...resyncOrder,
        ...downloadPrescription,
        ...returnRequest,
        ...cancelFullFilament,
        ...rto,
        ...reattempt
      };
    } else if (role === "doctor_admin") {
      actionsToReturn = {
        ...assignDoctor,
        ...assignClinic,
        ...assignBack,
        ...prescription,
        ...sendToDispatch,
        ...engagements,
        ...markAsDelivered,
        ...updateWarehouseAndMarkShipped,
        // ...voidOrder,
        ...RTOVoidOrder,
        ...resyncOrder,
        ...downloadPrescription,
        ...rto,
        ...reattempt
      };
    } else if (supportRole.includes(role)) {
      actionsToReturn = {
        ...assignDoctor,
        ...assignClinic,
        ...prescription,
        ...sendToDispatch,
        ...engagements,
        ...downloadPrescription,
        ...rto,
        ...reattempt
      };
    }
    return orderCancellationDisabledStatus.includes(order.status)
      ? { ...actionsToReturn, ...returnRequest }
      : { ...actionsToReturn, ...cancelOrderAction, ...returnRequest };
  };

  const [renderActions, setRenderedOptions] = useState(commonActions);
  useEffect(() => {
    setRenderedOptions(actions());
  }, []);
  const { prescriptionsData, fetchPrescriptionData } = usePrescription();

  useEffect(() => {
    if (order?.case_id) {
      fetchPrescriptionData(order?.case_id);
    }
  }, [customerId]);

  return (
    renderActions &&
    Object.keys(renderActions).length && (
      <div className="d-flex align-self-center gap-3 flex-wrap fs-2">
        {Object.entries(renderActions)?.map(([name, buttonText], index) => {
          if (
            name === "Resync Order" &&
            secureLocalStorage.getItem("is_supervisor") !== "true"
          ) {
            return null;
          } else {
            return (
              <div key={index}>
                <CustomComponent
                  order={order}
                  name={name}
                  userId={userId}
                  orderId={order?.id}
                  status={order?.status}
                  customerId={customerId}
                  buttonText={buttonText}
                  isBulk={order?.is_bulk_order}
                  prescriptions={prescriptions}
                  currentId={order?.order_display_id}
                  prescriptionsData={prescriptionsData}
                  isSingleOrder={order?.is_single_order}
                  isSubscriptionOrder={order?.is_subscription_order}
                  customer={customer}
                />
              </div>
            );
          }
        })}
      </div>
    )
  );
}

export default OrderActions;
